export default __webpack_public_path__ + "static/assets/a63304cdd65bbd7f34b63bf668e89b13.png";